import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const testimonials = [
  {
    id: 1,
    quote: `<b>The Journey of Nanbhat Janhit Society</b><br/><br/>
In 2003, elections were announced for the position of director at the Welfare Catholic Co-operative Bank. It was felt that this could be an opportunity for Nanbhat village to gain representation. Senior and experienced members of the village came together to discuss contesting this election. However, due to a smaller number of members and insufficient support from neighboring areas, the attempt failed. Still, it was decided in principle that Nanbhat should contest the election independently. Unfortunately, this attempt also did not succeed.<br/><br/>
During this election, an important aspect emerged — the people of Nanbhat voted wholeheartedly. This highlighted the social bonds and trust among the villagers. From this realization, the village decided that this unity should be directed towards the overall development of the village.<br/><br/>
Community Participation and Representation<br/><br/>
For future progress, discussions were held in the village assembly, and decisions were made unanimously. Accordingly, representatives were selected from various areas:<br/><br/>
From Akole, Chicholi, Nifad, Akkalkuwa, Sillod, and Nashik talukas — 2 representatives each<br/><br/>
From Wakod, Ghotigaon, Bhalod, Bhend, Urkad, and Manjare villages — 1 representative each <br/> <br/>
These representatives, along with senior members, discussed and drafted a development plan.<br/><br/>
With this vision, the journey of the Nanbhat Janhit Society began, taking steps toward inclusive and sustainable development.`,
  },
  {
    id: 2,
    quote: `<b>नानभाट जनहित सोसायटीची वाटचाल </b> <br/><br/>
सन 2003 मध्ये वेल्फेअर कॅथोलिक को. ऑप. बँकेच्या संचालक पदाच्या निवडणुका जाहीर झाल्या. ही संधी नानभाट गावाला प्रतिनिधित्व मिळवून देणारी ठरू शकते, असे वाटले. गावातील ज्येष्ठ मंडळी व अनुभवी लोकांनी एकत्र येऊन ही निवडणूक लढविण्याबाबत चर्चा केली. मात्र, सभासदसंख्या कमी असल्याने व आजूबाजूच्या परिसरातून अपेक्षित साथ न मिळाल्याने प्रयत्न अपयशी ठरले. तरीसुद्धा मनोमन ठरवून नानभाटने स्वतंत्रपणे निवडणूक लढवावी, असे ठरविण्यात आले. पण हा प्रयत्नही यशस्वी झाला नाही.
या निवडणुकीदरम्यान एक महत्त्वपूर्ण बाब समोर आली – नानभाटकरांनी एकदिलाने मतदान केले होते. यावरून त्यांच्या परस्परांतील सामाजिक बंध व विश्वास अधोरेखित झाले. या जाणिवेतून गावाने ठरविले की हा एकोपा गावाच्या सर्वांगीण विकासासाठी वळवावा.
सामुदायिक सहभाग आणि प्रतिनिधित्व<br/><br/>
पुढील वाटचालीसाठी गावसभांद्वारे चर्चा घेण्यात आली व सर्वानुमते निर्णय घेण्यात आले. यानुसार विविध भागांतून प्रतिनिधींची निवड झाली :
अकोले, चिचोली, निफड, अक्कलकुवा, सिल्लोड व नाशिक या तालुक्यांतून प्रत्येकी २ प्रतिनिधी
वाकोड, घोटीगाव, भालोद, भेंड, ऊरकड व मांजरे या गावांतून प्रत्येकी १ प्रतिनिधी
या प्रतिनिधींनी ज्येष्ठ मंडळींसोबत विचारविनिमय करून विकासाचा आराखडा आखला.
प्रस्तावित उपक्रम<br/><br/>
खालील क्षेत्रे प्राधान्याने निश्चित करण्यात आली :
वैद्यकीय मदत निधी<br/><br/>
शैक्षणिक मदत निधी<br/><br/>
सामाजिक जाणिवाबाबत प्रवोधन<br/><br/>
नानभाट म्हणून कायम एकत्रित राहणे<br/><br/>
या ध्येयदृष्टीने नानभाट जनहित सोसायटीची वाटचाल सुरू झाली आणि सर्वसमावेशक तसेच शाश्वत प्रगतीकडे पावले टाकली.`,
  },
];

const Language = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef(null);
  const [cardWidth, setCardWidth] = useState(0);
  const [expanded, setExpanded] = useState(false); // for Read More

  useEffect(() => {
    const updateWidth = () => {
      if (carouselRef.current) {
        setCardWidth(carouselRef.current.offsetWidth);
      }
    };
    window.addEventListener("resize", updateWidth);
    updateWidth();
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const handleNext = () => setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  const handlePrev = () => setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));

  const toggleReadMore = () => setExpanded(!expanded);

  return (
    <section className="py-16 bg-white relative overflow-hidden">
      <h2 className="text-4xl font-bold text-center text-brandRed mb-12">HISTORY</h2>

      <div className="relative flex items-center justify-center w-full px-4">
        <button
          onClick={handlePrev}
          className="absolute left-0 md:left-4 z-10 p-3 bg-white rounded-full shadow-md text-brandRed hover:bg-gray-100 focus:outline-none"
          aria-label="Previous Testimonial"
        >
          <FaChevronLeft size={20} />
        </button>

        <div
          ref={carouselRef}
          className="flex overflow-hidden w-full max-w-4xl lg:max-w-6xl font-body"
        >
          <motion.div
            className="flex space-x-8 pb-4"
            animate={{ x: -currentIndex * (cardWidth + 32) }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
          >
            {testimonials.map((testimonial) => {
              // truncate for small screens
              const truncatedQuote =
                testimonial.quote.length > 500 ? testimonial.quote.slice(0, 500) + "..." : testimonial.quote;

              return (
                <div
                  key={testimonial.id}
                  style={{ width: cardWidth }}
                  className="flex-shrink-0 bg-[#fff7f0] rounded-lg p-6 shadow-md flex flex-col justify-between"
                >
                  <div
                    className="text-brandRed font-body text-base flex-grow mb-4 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: expanded ? testimonial.quote : truncatedQuote }}
                  />
                  {testimonial.quote.length > 500 && (
                    <button
                      onClick={toggleReadMore}
                      className="text-brandRed font-bold mt-2 underline hover:text-red-700 self-start"
                    >
                      {expanded ? "Read Less" : "Read More"}
                    </button>
                  )}
                </div>
              );
            })}
          </motion.div>
        </div>

        <button
          onClick={handleNext}
          className="absolute right-0 md:right-4 z-10 p-3 bg-white rounded-full shadow-md text-brandRed hover:bg-gray-100 focus:outline-none"
          aria-label="Next Testimonial"
        >
          <FaChevronRight size={20} />
        </button>
      </div>

      <div className="flex justify-center mt-8 space-x-2">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`w-3 h-3 rounded-full ${index === currentIndex ? "bg-brandRed" : "bg-gray-300"} transition-colors duration-300`}
            onClick={() => setCurrentIndex(index)}
            aria-label={`Go to testimonial ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Language;
